import { useState } from "react";
import { Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useCmsHook } from "./cmsHook";
import { CmsConstructor } from "./cmsConstructor";
import { useDispatch } from "react-redux";

const CmsEditAndSave = () => {
  const [closeBtn, setCloseBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const {
    cmsInstance,
    isEdit,
    allowedUsers,
    setIsAllowedUser,
    isAllowedUser,
    setIsEdit,
    setCmsInstance,
  } = useCmsHook();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const userId = searchParams.get("userId");

  let isUserAllowed = false;
  for (const user of allowedUsers) {
    if (user.companyId === companyId && user.userId === userId) {
      isUserAllowed = true;
      break;
    }
  }

  if (isUserAllowed !== isAllowedUser && closeBtn === false) {
    setIsAllowedUser(isUserAllowed);
  }

  const handleEdit = () => {
    setIsEdit(true);
    setShowSaveBtn(true);
  };

  const handleClose = () => {
    setIsAllowedUser(false);
    setCloseBtn(true);
    setIsEdit(false);
  };

  const handlePreview = () => {
    setIsEdit(false);
  };

  const handleSaveChanges = () => {
    cmsInstance.saveContentChanges();
    setIsEdit(false);
    setShowSaveBtn(false);
  };

  const handleCancel = async () => {
    setIsEdit(false);
    setShowSaveBtn(false);
    const pmCmsInstance = await CmsConstructor(dispatch);
    setCmsInstance(pmCmsInstance);
  };

  return (
    <>
      {isAllowedUser && (
        <div className="pms-dialog-container d-flex flex-column justify-content-between">
          <div>
            <button className="close-button" onClick={handleClose}>
              &#x2716;
            </button>
          </div>
          <p className="text-center mt-2">
            To change the content click on the edit button below.
          </p>
          <div className="me-3 mb-3 cms-buttons-container">
            {window.location.pathname !== "/edit-notifications" && (
              <Button className="edit-notification-btn me-2 mb-2">
                <a
                  href={`/edit-notifications?companyId=${companyId}&userId=${userId}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Edit notifications
                </a>
              </Button>
            )}
            {showSaveBtn && (
              <Button
                className="save-content-changes-btn mb-2"
                onClick={() => handleSaveChanges()}
              >
                Save
              </Button>
            )}
            {!isEdit && (
              <Button
                className="save-content-changes-btn ms-2 mb-2"
                onClick={() => handleEdit()}
              >
                Edit
              </Button>
            )}

            {isEdit && (
              <button
                onClick={() => handlePreview()}
                className="preview-btn ms-2 mb-2"
              >
                Preview
              </button>
            )}
            {isEdit && (
              <button
                className="delete-modal-delete-btn ms-2 mb-2"
                onClick={() => handleCancel()}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CmsEditAndSave;
